import React, { useState, useEffect, useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import FocusLock from 'react-focus-lock';
/**
 *
 * Modal accesible que se inyecta en el DOM donde se invoca. Limita el foco a su contenido
 * y al cerrarse devuelve el foco al botón que se utilizó para abrir el modal.
 *
 */

const InlineDialog = ({ children, onClose, className = '' }) => (
  <FocusLock>
    <OutsideClickHandler onOutsideClick={onClose}>
      <div
        onKeyDown={e => e.key === 'Escape' && onClose(e)}
        role="dialog"
        className={className}
      >
        {children}
      </div>
    </OutsideClickHandler>
  </FocusLock>
);

export const useStateWithFocusManagement = (defaultState, openButtonRef) => {
  //devuelve el foco al botón de abrir al cerrar el menu
  const [isOpen, setIsOpen] = useState(defaultState);
  const notYetInteractedRef = useRef(true);
  useEffect(() => {
    if (notYetInteractedRef.current) {
      notYetInteractedRef.current = false;
    } else {
      !isOpen &&
        openButtonRef &&
        openButtonRef.current &&
        openButtonRef.current.focus &&
        openButtonRef.current.focus();
    }
  }, [notYetInteractedRef, isOpen, openButtonRef]);
  return [isOpen, setIsOpen];
};
export default InlineDialog;
